import { render, staticRenderFns } from "./IntroductionRequestBtn.vue?vue&type=template&id=64d3bda8&"
import script from "./IntroductionRequestBtn.vue?vue&type=script&lang=js&"
export * from "./IntroductionRequestBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports